import { useEffect, useState } from 'react';
import type { ExplorerViewFilters } from '../../../server/utils/explorer-utils.ts';

export const usePreventExplorerUnnecissearyRerender = (
    filters: ExplorerViewFilters,
    activeFilterTab: keyof ExplorerViewFilters,
    hideUnselectedRows: boolean,
) => {
    const [filtersWithRerenderProtection, setFiltersWithRerenderProtection] = useState(filters);

    useEffect(() => {
        if (hideUnselectedRows) {
            // This will trigger a new API call and a rerender
            // eslint-disable-next-line react-hooks/set-state-in-effect -- legacy code
            setFiltersWithRerenderProtection(filters);
        } else {
            // Here we need to check if any of the filters EXCEPT for the one for activeFilterTab are differnt in filtersWithRerenderProtection
            const filtersWithRerenderProtectionCopy = { ...filtersWithRerenderProtection };
            const filtersCopy = { ...filters };
            delete filtersWithRerenderProtectionCopy[activeFilterTab];
            delete filtersCopy[activeFilterTab];
            const filtersWithRerenderProtectionCopyValues = Object.values(filtersWithRerenderProtectionCopy);
            const filtersCopyValues = Object.values(filtersCopy);
            const filtersWithRerenderProtectionCopyString = filtersWithRerenderProtectionCopyValues.join('');
            const filtersCopyString = filtersCopyValues.join('');

            // If they are, we set filtersWithRerenderProtection to filters
            // If they are not, we do nothing - PREVENTS A NEW API CALL AND RERENDER
            if (filtersWithRerenderProtectionCopyString !== filtersCopyString) {
                setFiltersWithRerenderProtection(filters);
            }
        }
    }, [filters, activeFilterTab]);

    return {
        filtersWithRerenderProtection,
    };
};
